import ApiService from "@/common/api/api.service";

export const ProductService = {

    list() {
        ApiService.setHeader()
        return ApiService.get('product')
    },
    search(page=1, itemsPerPage=10, active=true, search="", orderBy = "", sortDesc = "") {
        ApiService.setHeader()
        return ApiService.get(`product?page=${page}&itemsPerPage=${itemsPerPage}&active=${active}&search=${search}&orderBy=${orderBy}&sortDesc=${sortDesc}`)
    },
    listSimple() {
        ApiService.setHeader()
        return ApiService.get('product/simple')
    },
    searchSimple(slug) {
        ApiService.setHeader()
        return ApiService.get('product/simple', slug)
    },

    brandSearch(slug) {
        ApiService.setHeader()
        return ApiService.get('brand/search', slug)
    },
    get(slug) {
        ApiService.setHeader()
        return ApiService.get('product', slug)
    },
    get_parameters(){
        ApiService.setHeader()
        return ApiService.get('product','parameters')
    },
    update(slug, data) {
        ApiService.setHeader()
        return ApiService.update('product', slug, data)
    },
    post(slug, data) {
        ApiService.setHeader()
        return ApiService.post('product', data)
    },
    updateStock(slug, id, data) {
        ApiService.setHeader()
        return ApiService.post(`product/${id}/stock`, data)
    },

    active(id) {
        ApiService.setHeader()
        return ApiService.update(`product/${id}/active`)
    },
    inactive(id) {
        ApiService.setHeader()
        return ApiService.update(`product/${id}/inactive`)
    },

    delete(id) {
        ApiService.setHeader()
        return ApiService.delete(`product/${id}`)
    }

 
}